import React from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";
import { formatMoney } from "../../../../app/util/formatUtils";
import { getNombreMoneda } from "../../../../app/util/textCodeUtils";

const TransferenciasCuentasPrymeraResumen = ({
  cuentaOrigen,
  cuentaDestino,
  aplicaTipoCambio,
  tipoCambio,
  itfTransferencia,
  codigoMonedaTransferencia,
  importeTotalTransferir,
  transferenciaExitosa,
  nombreTitularDestino,
  importeDebitarValidado,
  monedaDebitarValidado,
  importeTransferirValidado,
  monedaTransferirValidado,
}) => {
  return (
    <>
      <Table singleLine>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Cuenta de origen:</Table.Cell>
            <Table.Cell>{cuentaOrigen}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Cuenta de destino:</Table.Cell>
            <Table.Cell>{cuentaDestino}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Titular cuenta destino:</Table.Cell>
            <Table.Cell>{nombreTitularDestino}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Monto:</Table.Cell>
            <Table.Cell>{`${getNombreMoneda(
              codigoMonedaTransferencia
            )} ${formatMoney(importeTotalTransferir)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>ITF:</Table.Cell>
            <Table.Cell>{`${formatMoney(itfTransferencia)}`}</Table.Cell>
          </Table.Row>
          {aplicaTipoCambio === true && (
            <>
              <Table.Row active>
                <Table.Cell>Información adicional</Table.Cell>
                <Table.Cell />
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tipo de cambio:</Table.Cell>
                <Table.Cell>{tipoCambio}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto a debitar:</Table.Cell>
                <Table.Cell>{`${getNombreMoneda(
                  monedaDebitarValidado
                )} ${formatMoney(importeDebitarValidado)}`}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto a transferir:</Table.Cell>
                <Table.Cell>{`${getNombreMoneda(
                  monedaTransferirValidado
                )} ${formatMoney(importeTransferirValidado)}`}</Table.Cell>
              </Table.Row>
            </>
          )}
        </Table.Body>
      </Table>
    </>
  );
};
TransferenciasCuentasPrymeraResumen.propTypes = {
  cuentaOrigen: PropTypes.string.isRequired,
  cuentaDestino: PropTypes.string.isRequired,
  aplicaTipoCambio: PropTypes.bool.isRequired,
  tipoCambio: PropTypes.number,
  itfTransferencia: PropTypes.number.isRequired,
  codigoMonedaTransferencia: PropTypes.string.isRequired,
  importeTotalTransferir: PropTypes.number.isRequired,
  transferenciaExitosa: PropTypes.bool,
  nombreTitularDestino: PropTypes.string.isRequired,
  importeDebitarValidado: PropTypes.number.isRequired,
  monedaDebitarValidado: PropTypes.string.isRequired,
  importeTransferirValidado: PropTypes.number.isRequired,
  monedaTransferirValidado: PropTypes.string.isRequired,
};

export default TransferenciasCuentasPrymeraResumen;
